import uuid from 'react-uuid';
import sanitizeFileName from './sanitizeFileName';
import setFileNameExtension from './setFileNameExtension';

export default function prepareFileName({
  meta: { name },
  extension
}) {
  const sanitizedName = sanitizeFileName(name);
  const sanitizedExtension = sanitizeFileName(extension);
  const sanitizedNameWithExtension = setFileNameExtension(sanitizedName, sanitizedExtension);
  const uniqueName = `${uuid()}_${sanitizedNameWithExtension}`;

  return {
    displayName: sanitizedNameWithExtension,
    extension: sanitizedExtension,
    uniqueName,
  };
}
